// extracted by mini-css-extract-plugin
module.exports = {"container":"archive-pagination-module--container--18uDF","buttonLeft":"archive-pagination-module--buttonLeft--25vg7","buttonRight":"archive-pagination-module--buttonRight--2ZMPL"};